import { ActionTypes } from "@/App/constants/actionTypes";
import { GeneralTypes } from "@/types";

type getMemberAction = {
  type: typeof ActionTypes.GET_MEMBER_INFORMATION;
  payload: string;
};

export const getMember = (data: string): getMemberAction => {
  return {
    type: ActionTypes.GET_MEMBER_INFORMATION,
    payload: data,
  };
};

type getMemberResultsAction = {
  type: typeof ActionTypes.GET_MEMBER_INFORMATION_RESULTS;
  payload: GeneralTypes.Dictionary;
};

export const getMemberResults = (data: GeneralTypes.Dictionary): getMemberResultsAction => {
  return {
    type: ActionTypes.GET_MEMBER_INFORMATION_RESULTS,
    payload: data,
  };
};

export type getMemberActions = getMemberResultsAction | getMemberAction;
